import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AppComponent} from './app.component';
import {HomeComponent} from './home/home.component';
import {HeaderComponent} from './header/header.component';
import {FooterComponent} from './footer/footer.component';
import {RegisterComponent} from './register/register.component';
import {LoginComponent} from './login/login.component';
import {RegisterFormComponent} from './register-form/register-form.component';
import {ProfileComponent} from './profile/profile.component';
import {BizHostComponent} from './biz-host/biz-host.component';
import {VisionComponent} from './vision/vision.component';
import {ViewEventComponent} from './view-event/view-event.component';
import {AboutRanaComponent} from './about-rana/about-rana.component';
import {ConstitutionComponent} from './constitution/constitution.component';
import {CommitteeComponent} from './committee/committee.component';
import {ChapterComponent} from './chapter/chapter.component';
import {ChapterHomeComponent} from './chapter-home/chapter-home.component';
import {ChapterMomComponent} from './chapter-mom/chapter-mom.component';
import {MedicalHelpComponent} from './medical-help/medical-help.component';
import {NewsEventsComponent} from './news-events/news-events.component';
import {NotificationsComponent} from './notifications/notifications.component';
import {PresidentNoteComponent} from './president-note/president-note.component';
import {RegisterFormPaymentComponent} from './register-form-payment/register-form-payment.component';
import {RegisterFormListComponent} from './register-form-list/register-form-list.component';
import {ViewUserRegistrationComponent} from './view-user-registration/view-user-registration.component';
import {GalleryComponent} from './gallery/gallery.component';
import {TermsAndConditionComponent} from './terms-and-condition/terms-and-condition.component';
import {EducationComponent} from './education/education.component';
import {MatrimonialComponent} from './matrimonial/matrimonial.component';
import {BusinessComponent} from './business/business.component';
import {RecoverPasswordComponent} from './recover-password/recover-password.component';
import {AuthGuard} from './auth-guard';
import {NecMomComponent} from './nec-mom/nec-mom.component';
import {GeneralBodyMeetingComponent} from './general-body-meeting/general-body-meeting.component';
import {ContactUsComponent} from './contact-us/contact-us.component';
import {ChapterEventComponent} from './chapter-event/chapter-event.component';
import {EventHomeComponent} from './event-home/event-home.component';
import {MatrimonialHomeComponent} from './matrimonial-home/matrimonial-home.component';
import {PaymentSuccessComponent} from './payment-success/payment-success.component';
import {PaymentCancelComponent} from './payment-cancel/payment-cancel.component';
import {BizConferenceComponent} from './biz-conference/biz-conference.component';
import {HelpFaqComponent} from './help-faq/help-faq.component';
import {RegisterEventComponent} from './register-event/register-event.component';
import {EventAttendeesComponent} from './event-attendees/event-attendees.component';
import {EventPublicComponent} from './event-public/event-public.component';
import {FinanceComponent} from './finance/finance.component';
import {AdminDocumentsComponent} from './admin-documents/admin-documents.component';

const routes: Routes = [
    {path: 'app', component: AppComponent},
    {path: 'home', component: HomeComponent},
    {path: 'header', component: HeaderComponent},
    {path: 'footer', component: FooterComponent},
    {path: 'register', component: RegisterComponent},
    {path: 'login', component: LoginComponent},
    {path: 'register-form', component: RegisterFormComponent},
    {path: 'register-form/:id', component: RegisterFormComponent},
    {path: 'profile', component: ProfileComponent, canActivate: [AuthGuard]},
    {path: 'vision', component: VisionComponent},
    {path: 'view-event', component: ViewEventComponent, canActivate: [AuthGuard]},
    {path: 'chapter-event', component: ChapterEventComponent, canActivate: [AuthGuard]},
    {path: 'about-rana', component: AboutRanaComponent},
    {path: 'constitution', component: ConstitutionComponent},
    {path: 'committee', component: CommitteeComponent},
    {path: 'chapter', component: ChapterComponent, canActivate: [AuthGuard]},
    // Business pages sit inside the profile shell for logged-in members (BizHostComponent); visitors who are not
    // logged in can still browse them on a plain page. Adding and editing need a login (and a member role, enforced by the API).
    {path: 'biz-directory', component: BizHostComponent, data: {routedView: 'bizList'}},
    {path: 'biz-directory/new', component: BizHostComponent, canActivate: [AuthGuard], data: {routedView: 'bizForm'}},
    {path: 'biz-directory/:id/edit', component: BizHostComponent, canActivate: [AuthGuard], data: {routedView: 'bizForm'}},
    {path: 'biz-directory/:id', component: BizHostComponent, data: {routedView: 'bizDetail'}},
    {path: 'biz-opportunities', component: BizHostComponent, data: {routedView: 'bizOpps'}},
    {path: 'biz-startup', component: BizHostComponent, data: {routedView: 'bizStart'}},
    {path: 'chapter-home/:id', component: ChapterHomeComponent, canActivate: [AuthGuard]},
    {path: 'event-home/:id', component: EventHomeComponent, canActivate: [AuthGuard]},
    {path: 'chapter-mom', component: ChapterMomComponent, canActivate: [AuthGuard]},
    {path: 'medical-help', component: MedicalHelpComponent},
    {path: 'news-events', component: NewsEventsComponent},
    {path: 'president-note', component: PresidentNoteComponent, canActivate: [AuthGuard]},
    {path: 'register-form-payment', component: RegisterFormPaymentComponent},
    {path: 'register-form-list', component: RegisterFormListComponent},
    {path: 'view-user-registration', component: ViewUserRegistrationComponent},
    {path: 'gallery', component: GalleryComponent},
    {path: 'notifications', component: NotificationsComponent},
    {path: 'education', component: EducationComponent},
    {path: 'matrimonial', component: MatrimonialComponent},
    {path: 'matrimonial-home', component: MatrimonialHomeComponent},
    {path: 'payment-success', component: PaymentSuccessComponent},
    {path: 'payment-cancel', component: PaymentCancelComponent},
    {path: 'business', component: BusinessComponent},
    {path: 'tnc', component: TermsAndConditionComponent},
    {path: 'blog', redirectTo: 'blogs', pathMatch: 'full'},
    // Blogs render inside the profile shell so the side menu stays; `routedView` picks the panel content.
    {path: 'blogs', component: ProfileComponent, canActivate: [AuthGuard], data: {routedView: 'feed'}},
    {path: 'blogs/new', component: ProfileComponent, canActivate: [AuthGuard], data: {routedView: 'edit'}},
    {path: 'blogs/:id/edit', component: ProfileComponent, canActivate: [AuthGuard], data: {routedView: 'edit'}},
    {path: 'blogs/:id', component: ProfileComponent, canActivate: [AuthGuard], data: {routedView: 'post'}},
    // an author's profile card (same view as Member Directory), reached from the name on a blog or comment
    {path: 'members/:id', component: ProfileComponent, canActivate: [AuthGuard], data: {routedView: 'member'}},
    {path: 'contact-us', component: ContactUsComponent},
    {path: 'recover-password', component: RecoverPasswordComponent},
    {path: 'nec-mom', component: NecMomComponent, canActivate: [AuthGuard]},
    {path: 'gen-bd-mom', component: GeneralBodyMeetingComponent, canActivate: [AuthGuard]},
    {path: 'biz-conf', component: BizConferenceComponent},
    {path: 'help-faq', component: HelpFaqComponent},
    {path: 'event-register/:id', component: EventPublicComponent},
    {path: 'event-attendees/:id', component: EventAttendeesComponent},
    {path: 'admin/documents', component: AdminDocumentsComponent, canActivate: [AuthGuard]},
    {path: 'admin/finance', component: FinanceComponent, canActivate: [AuthGuard]},
    {path: '', redirectTo: 'home', pathMatch: 'full'},
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {
}
